/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：532
 */

function n(t) {
  module.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e)
  }
  return n(t)
}
module.exports = n
